import React from 'react'

export const DecisionContext = React.createContext()
